export default "__VITE_ASSET__0ae80007__"